import React from 'react';

import PropTypes from 'prop-types';
import { Box, StackView, Typography } from '@telus-uds/components-web';

import InfoListRow from '../orderDetailsSection/tankdetails/components/infoListRow';
import { DetailsGrid } from './css';

const SummaryTankDetails = ({ tankDetails }) => {
  return (
    <>
      {tankDetails.length > 0 && (
        <StackView space={3}>
          <Typography heading="h4" variant={{ size: 'h4' }} block>Tank Details</Typography>
          <DetailsGrid>
            {tankDetails.map((detail, index) => (
              <InfoListRow showDelete={false} row={detail} rowIndex={index} />
            ))}
          </DetailsGrid>
        </StackView>
      )}
    </>
  );
};

SummaryTankDetails.propTypes = {
  tankDetails: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default SummaryTankDetails;
